import type { EnhancedStore } from '@reduxjs/toolkit';
import type { RootState, AppDispatch } from './index';

type AppStore = EnhancedStore<RootState, any, any> & { dispatch: AppDispatch };

// Dependency-free store handle. Modules that only need `store` inside a
// deferred callback (axios interceptors, logout handlers) should import this
// instead of `./index` directly — importing `./index` there creates a cycle
// back through the RTK Query api slices that store/index.ts registers,
// which makes module evaluation order (and Vite HMR) unreliable.
let storeInstance: AppStore | null = null;

export const setStore = (store: AppStore): void => {
  storeInstance = store;
};

export const getStore = (): AppStore => {
  if (!storeInstance) {
    throw new Error('Store accessed before initialization');
  }
  return storeInstance;
};
